import type { ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

type MainModalLayoutContextValue = {
  /** DOM node where compact-mode primary actions are portaled. */
  footerMount: HTMLDivElement | null;
  setFooterMount: (el: HTMLDivElement | null) => void;
};

const MainModalLayoutContext = createContext<MainModalLayoutContextValue | null>(null);

export function MainModalLayoutProvider({ children }: Readonly<{ children: ReactNode }>) {
  const [footerMount, setFooterMount] = useState<HTMLDivElement | null>(null);
  const value = useMemo(
    () => ({ footerMount, setFooterMount }),
    [footerMount],
  );

  return (
    <MainModalLayoutContext.Provider value={ value }>
      { children }
    </MainModalLayoutContext.Provider>
  );
}

export function useMainModalLayout(): MainModalLayoutContextValue | null {
  return useContext(MainModalLayoutContext);
}
